// extracted by mini-css-extract-plugin
module.exports = {"featured_item":"slider_featured_item__RJqTE","featured_image":"slider_featured_image__x3g6A","featured_caption":"slider_featured_caption__2V1P4"};